import { Text } from '@/_components';

export function NoInventoryVendors() {
  return (
    <article className="flex flex-1 justify-center pt-6 pb-10">
      <Text className="text-accent-light font-normal dark:text-gray-500" as="small">
        No Vendors
      </Text>
    </article>
  );
}
